/**
 * An invitation link opened before sign-in is remembered here (the accept
 * screen stores the token), and every way a sign-in can finish asks this
 * module where to go. Before 2026-10-01 only two of five endings asked, so
 * an invitee who signed in with a password, a text code or the Recovery
 * Code unlock landed on the dashboard and the invitation was gone.
 */
import AsyncStorage from '@react-native-async-storage/async-storage';

export const INVITATION_TOKEN_KEY = '@invitation_token';

export async function getPendingInvitationToken(): Promise<string | null> {
  try {
    const token = await AsyncStorage.getItem(INVITATION_TOKEN_KEY);
    return token && token.trim() ? token : null;
  } catch {
    return null;
  }
}

export function invitationRoute(token: string) {
  return { index: 0, routes: [{ name: 'AcceptInvitation', params: { token } }] };
}

/**
 * Resets to the accept screen when an invitation is waiting. Returns true
 * when it navigated, so the caller stops its own routing.
 */
export async function routeToPendingInvitationIfAny(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  navigation: { reset: (state: any) => void },
): Promise<boolean> {
  const token = await getPendingInvitationToken();
  if (!token) return false;
  navigation.reset(invitationRoute(token));
  return true;
}
